import Index from '../components/ProductOrder/Index';

let routes = {
    path: '/productOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/productOrder',
            component: Index
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/productOrder.js